import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import {
  Types as ParticipantDashboardTypes,
  Creators as ParticipantDashboardActions,
} from '../ducks/ParticipantDashboard';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getParticipantTopNumbers() {
  try {
    const { status, data } = yield call(api.get, '/participant-dashboard/top-numbers');
    if (status === 200) {
      yield put(
        ParticipantDashboardActions.getParticipantTopNumbersSuccess(data)
      );
    } else {
      Sentry.captureMessage('getParticipantTopNumbers failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(
        ParticipantDashboardActions.getParticipantTopNumbersError(
          'Error listing topnumbers'
        )
      );
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(
      ParticipantDashboardActions.getParticipantTopNumbersError(
        'Error listing topnumbers'
      )
    );
  }
}

function* getParticipantTopNumbersWatcher() {
  yield takeLatest(
    ParticipantDashboardTypes.GET_PARTICIPANT_TOP_NUMBERS,
    getParticipantTopNumbers
  );
}


export default function* rootSaga() {
  yield all([
    fork(getParticipantTopNumbersWatcher),
  ]);
}
